/* istanbul ignore file */
import SingleLeadBreadcrumbs from 'domain/sales/lead/shared/SingleLeadBreadcrumbs';
import { ActivitiesAndNotesBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useLeadId } from 'domain/sales/lead/leadRouting';
import { useLeadUrl } from 'domain/shared/lead';

const LeadTimelineBreadcrumbs = () => {
  const { getTimelineUrl } = useLeadUrl();
  const id = useLeadId();

  return (
    <SingleLeadBreadcrumbs>
      <ActivitiesAndNotesBreadcrumbItem link={getTimelineUrl(id)} />
    </SingleLeadBreadcrumbs>
  );
};

export default LeadTimelineBreadcrumbs;
